import React from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AdminSidebar } from './AdminSidebar';
import { Badge } from '@/components/ui/badge';
import { useSecureAdminAuth } from '@/hooks/useSecureAdminAuth';
import { Button } from '@/components/ui/button';
import { LogOut, User } from 'lucide-react';
import EnhancedSecureAdminProtection from './EnhancedSecureAdminProtection';

export function AdminLayout() {
  const { adminUser, logout } = useSecureAdminAuth();

  return (
    <EnhancedSecureAdminProtection>
      <SidebarProvider>
        {/* Header global avec trigger sidebar TOUJOURS visible */}
        <header className="h-14 flex items-center justify-between border-b bg-background px-4 sticky top-0 z-50">
          <div className="flex items-center gap-4">
            <SidebarTrigger className="p-2" />
            <div className="flex items-center gap-2">
              <h1 className="font-semibold">Administration FEEL</h1>
              <Badge variant="secondary" className="text-xs">
                Pro
              </Badge>
            </div>
          </div>

          {/* Info admin + déconnexion */}
          <div className="flex items-center gap-3">
            {adminUser && (
              <div className="flex items-center gap-2 text-sm">
                <User className="h-4 w-4" />
                <span className="hidden sm:inline">{adminUser.email}</span>
                <Badge variant="outline" className="text-xs">
                  {adminUser.role}
                </Badge>
              </div>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              className="gap-2"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Déconnexion</span>
            </Button>
          </div>
        </header>

        <div className="flex min-h-[calc(100vh-3.5rem)] w-full">
          <AdminSidebar />
          
          <main className="flex-1 p-6">
            <Outlet />
          </main>
        </div>
      </SidebarProvider>
    </EnhancedSecureAdminProtection>
  );
}